export default function(array, filter, visitor) {
  if (array) {
    var i = 0, n = array.length, t;
    if (filter) {
      for (; i<n; ++i) {
        if (t = filter(array[i])) visitor(t, i, array);
      }
    } else {
      array.forEach(visitor);
    }
  }
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/vega-tooltip/node_modules/vega-util/src/visitArray.js
// module id = null
// module chunks = 